module.exports = {"id":"206006","name":"Ezgjan Alioski","rating":"72","photo":"./data/images/photos/2/206006.png","club":{"name":"Leeds Utd","logo":"./data/images/clubs/LeedsUtd.png"},"positions":["MD","MG"],"photoFolderIndex":2}


//////////////////
// WEBPACK FOOTER
// ./src/data/players/EzgjanAlioski0.json
// module id = 1322
// module chunks = 0